import { zGraphemeString } from '../../../../validation/grapheme';
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SAS Online Clinic Backend API
 * SASオンラインクリニックのバックエンドAPI仕様。分割YAML構成で管理し、RedoclyとSpectralで検証します。
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * 指定された患者（patientId）の請求一覧を返します。
 * @summary 患者の請求一覧を取得する
 */
export const PatientListInvoicesParams = zod.object({
  "patientId": zod.string().uuid().describe('患者ユーザーID（UUID）')
}).strict()

export const patientListInvoicesQueryPageDefault = 0;
export const patientListInvoicesQueryPageMin = 0;

export const patientListInvoicesQuerySizeDefault = 20;
export const patientListInvoicesQuerySizeMax = 2000;

export const patientListInvoicesQuerySortDefault = `createdAt,desc`;

export const PatientListInvoicesQueryParams = zod.object({
  "page": zod.number().int().min(patientListInvoicesQueryPageMin).default(patientListInvoicesQueryPageDefault).describe('取得ページ番号（0開始）'),
  "size": zod.number().int().min(1).max(patientListInvoicesQuerySizeMax).default(patientListInvoicesQuerySizeDefault).describe('1ページあたりの件数'),
  "sort": zod.string().default(patientListInvoicesQuerySortDefault).describe('ソートキー（例: createdAt,desc）')
}).strict()

export const patientListInvoicesResponseItemsItemInvoiceAmountMultipleOf = 1;

export const patientListInvoicesResponseItemsItemInvoicePdfResourcePathRegExp = new RegExp('^/(patients|uploads)/.+');
export const patientListInvoicesResponseItemsItemStatementPdfResourcePathRegExp = new RegExp('^/(patients|uploads)/.+');
export const patientListInvoicesResponseItemsItemAdditionalAttachmentResourcePathsItemMax = 2048;


export const patientListInvoicesResponseItemsItemAdditionalAttachmentResourcePathsItemRegExp = new RegExp('^/(patients|uploads)/.+');
export const patientListInvoicesResponseItemsItemAdditionalAttachmentResourcePathsMax = 10;

export const patientListInvoicesResponseItemsItemReceiptNumberMax = 128;

export const patientListInvoicesResponsePagePageMin = 0;

export const patientListInvoicesResponsePageSizeMax = 2000;

export const patientListInvoicesResponsePageTotalElementsMin = 0;

export const patientListInvoicesResponsePageTotalPagesMin = 0;



export const PatientListInvoicesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string().uuid().describe('請求ID（UUID）'),
  "invoiceAmount": zod.number().multipleOf(patientListInvoicesResponseItemsItemInvoiceAmountMultipleOf).describe('請求金額（通貨: JPY・税込）'),
  "invoicePdfResourcePath": zod.string().refine((v) => patientListInvoicesResponseItemsItemInvoicePdfResourcePathRegExp.test(v)).optional().describe('請求書PDFのメディアリソースパス（例: /patients/{patientId}/... または /uploads/{organizationId}/...、任意）'),
  "statementPdfResourcePath": zod.string().refine((v) => patientListInvoicesResponseItemsItemStatementPdfResourcePathRegExp.test(v)).optional().describe('明細書PDFのメディアリソースパス（例: /patients/{patientId}/... または /uploads/{organizationId}/...、任意）'),
  "additionalAttachmentResourcePaths": zod.array(zGraphemeString({ max: patientListInvoicesResponseItemsItemAdditionalAttachmentResourcePathsItemMax }).refine((v) => patientListInvoicesResponseItemsItemAdditionalAttachmentResourcePathsItemRegExp.test(v))).max(patientListInvoicesResponseItemsItemAdditionalAttachmentResourcePathsMax).optional().describe('その他添付のメディアリソースパス一覧（任意）'),
  "issuedDate": zod.string().date().describe('発行日（YYYY-MM-DD）'),
  "issuerName": zod.string().describe('発行者名'),
  "payeeName": zod.string().describe('支払い先名'),
  "isPaid": zod.boolean().describe('入金済みフラグ'),
  "invoiceLifecycleStatus": zod.enum(['NOT_BILLED', 'ACTIVE', 'PAID', 'REISSUED', 'CANCELLED']).describe('請求ライフサイクルステータス'),
  "paymentStatus": zod.enum(['企業請求', '未納', '決済エラー（カード）', '決済エラー（コンビニ）', 'カード決済済み', 'コンビニ決済済み', 'キャンセル済み', 'キャンセル済み（企業請求）']).describe('支払いステータス（表示ラベル）'),
  "selectedPaymentChannel": zod.enum(['CARD', 'CVS', 'COMPANY_DIRECT']).optional().describe('選択中の支払いチャネル（任意）'),
  "availablePatientActions": zod.array(zod.enum(['CHANGE_CARD', 'SWITCH_CHANNEL', 'SWITCH_KONBINI'])).describe('患者が実行可能なアクション一覧'),
  "konbiniCode": zod.enum(['SEVEN_ELEVEN', 'LAWSON', 'FAMILYMART', 'MINISTOP', 'SEICOMART']).optional().describe('コンビニ会社コード（CVS時、任意）'),
  "latestPaymentStatus": zod.string().optional().describe('最新決済試行の内部ステータス（任意）'),
  "latestFailureReason": zod.string().optional().describe('最新決済試行の失敗理由（任意）'),
  "latestPaymentAttemptedAt": zod.string().datetime({"offset":true}).optional().describe('最新決済試行日時（任意）'),
  "receiptNumber": zGraphemeString({ max: patientListInvoicesResponseItemsItemReceiptNumberMax }).optional().describe('コンビニ払い番号（CVS時、任意）'),
  "paymentDueDate": zod.string().date().nullish().describe('支払期限（CVS時、任意）'),
  "paidDate": zod.string().date().nullable().describe('入金日（YYYY-MM-DD）。未入金の場合はnull。'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('特定患者に対する請求情報')),
  "page": zod.object({
  "page": zod.number().int().min(patientListInvoicesResponsePagePageMin).describe('現在のページ番号（0開始）'),
  "size": zod.number().int().min(1).max(patientListInvoicesResponsePageSizeMax).describe('1ページあたりの件数'),
  "totalElements": zod.number().int().min(patientListInvoicesResponsePageTotalElementsMin).describe('全要素数'),
  "totalPages": zod.number().int().min(patientListInvoicesResponsePageTotalPagesMin).describe('全ページ数'),
  "hasNext": zod.boolean().describe('次のページがあるか'),
  "hasPrevious": zod.boolean().describe('前のページがあるか')
}).strict().describe('ページングメタ情報')
}).strict()

/**
 * 医療機関から特定の患者に対して請求を登録します。
 * @summary 請求を発行する
 */
export const invoiceCreateInvoiceBodyThreeIssuerNameMax = 200;

export const invoiceCreateInvoiceBodyThreeInvoiceAmountMin = 0;
export const invoiceCreateInvoiceBodyThreeInvoiceAmountMax = 100000000;
export const invoiceCreateInvoiceBodyThreeInvoiceAmountMultipleOf = 1;

export const invoiceCreateInvoiceBodyThreeInvoicePdfS3KeyMax = 1024;


export const invoiceCreateInvoiceBodyThreeInvoicePdfS3KeyRegExp = new RegExp('^[a-zA-Z0-9/_\\-\\.]+$');
export const invoiceCreateInvoiceBodyThreeStatementPdfS3KeyMax = 1024;


export const invoiceCreateInvoiceBodyThreeStatementPdfS3KeyRegExp = new RegExp('^[a-zA-Z0-9/_\\-\\.]+$');
export const invoiceCreateInvoiceBodyThreeAdditionalAttachmentS3KeysItemMax = 1024;


export const invoiceCreateInvoiceBodyThreeAdditionalAttachmentS3KeysItemRegExp = new RegExp('^[a-zA-Z0-9/_\\-\\.]+$');
export const invoiceCreateInvoiceBodyThreeAdditionalAttachmentS3KeysMax = 10;



export const InvoiceCreateInvoiceBody = zod.union([zod.object({
  "invoiceTargetType": zod.enum(['ONLINE_CONSULTATION'])
}).strict(),zod.object({
  "invoiceTargetType": zod.enum(['REFERRAL_ISSUANCE'])
}).strict()]).and(zod.object({
  "patientId": zod.string().uuid().describe('対象患者のユーザーID（UUID）'),
  "reservationId": zod.string().uuid().optional().describe('紐付ける予約ID（UUID）。請求対象種別が ONLINE_CONSULTATION の場合に指定します。'),
  "invoiceTargetType": zod.enum(['ONLINE_CONSULTATION', 'REFERRAL_ISSUANCE']).describe('請求対象種別（オンライン診療または紹介状発行）'),
  "referralRequestId": zod.string().uuid().optional().describe('紹介状依頼ID（請求対象種別が REFERRAL_ISSUANCE の場合に指定）'),
  "reissueFromInvoiceId": zod.string().uuid().optional().describe('再請求元の請求ID（UUID）。指定時は再請求として新しい請求を発行します。'),
  "issuerOrganizationId": zod.string().uuid().describe('発行元組織ID（UUID）。医療機関または委託事業者等の組織ID。'),
  "issuerName": zGraphemeString({ min: 1, max: invoiceCreateInvoiceBodyThreeIssuerNameMax }).describe('発行者名'),
  "invoiceAmount": zod.number().min(invoiceCreateInvoiceBodyThreeInvoiceAmountMin).max(invoiceCreateInvoiceBodyThreeInvoiceAmountMax).multipleOf(invoiceCreateInvoiceBodyThreeInvoiceAmountMultipleOf).describe('請求金額（通貨: JPY・税込）'),
  "issuedDate": zod.string().date().describe('発行日（YYYY-MM-DD）'),
  "selectedPaymentChannel": zod.enum(['CARD', 'CVS']).optional().describe('明示指定する支払いチャネル。未指定時は患者の決済プロファイル既定値を使用します。'),
  "selectedKonbiniCode": zod.enum(['SEVEN_ELEVEN', 'LAWSON', 'FAMILYMART', 'MINISTOP', 'SEICOMART']).optional().describe('selectedPaymentChannel=CVS の場合に利用するコンビニコード。未指定時は患者の既定コンビニコードを使用します。'),
  "invoicePdfS3Key": zGraphemeString({ max: invoiceCreateInvoiceBodyThreeInvoicePdfS3KeyMax }).refine((v) => invoiceCreateInvoiceBodyThreeInvoicePdfS3KeyRegExp.test(v)).optional().describe('請求書PDFのS3キー（任意）。アップロード初期化で purpose=invoice_pdf を指定して取得したキーを設定します。'),
  "statementPdfS3Key": zGraphemeString({ max: invoiceCreateInvoiceBodyThreeStatementPdfS3KeyMax }).refine((v) => invoiceCreateInvoiceBodyThreeStatementPdfS3KeyRegExp.test(v)).optional().describe('明細書PDFのS3キー（任意）。アップロード初期化で purpose=invoice_detail_pdf を指定して取得したキーを設定します。'),
  "additionalAttachmentS3Keys": zod.array(zGraphemeString({ max: invoiceCreateInvoiceBodyThreeAdditionalAttachmentS3KeysItemMax }).refine((v) => invoiceCreateInvoiceBodyThreeAdditionalAttachmentS3KeysItemRegExp.test(v))).max(invoiceCreateInvoiceBodyThreeAdditionalAttachmentS3KeysMax).optional().describe('その他添付のS3キー一覧（任意）。アップロード初期化で purpose=invoice_attachment_pdf を指定して取得したキーを列挙します。')
}).strict()).describe('請求発行の入力（医療機関→特定患者）')

export const InvoiceCreateInvoiceResponse = zod.object({
  "invoiceId": zod.string().uuid().describe('作成された請求ID（UUID）'),
  "invoiceLifecycleStatus": zod.enum(['NOT_BILLED', 'ACTIVE', 'PAID', 'REISSUED', 'CANCELLED']).describe('請求ライフサイクルステータス'),
  "paymentId": zod.string().uuid().optional().describe('支払い試行ID（決済発生時）'),
  "paymentStatus": zod.enum(['企業請求', '未納', '決済エラー（カード）', '決済エラー（コンビニ）', 'カード決済済み', 'コンビニ決済済み', 'キャンセル済み', 'キャンセル済み（企業請求）']).optional().describe('患者/医師画面で表示する支払い状態ラベル'),
  "selectedPaymentChannel": zod.enum(['CARD', 'CVS', 'COMPANY_DIRECT']).describe('初期推定の支払いチャネル（患者の決済プロファイルから導出。未設定時はCARDにフォールバック。実際の確定チャネルは決済起動後に永続化されます）'),
  "selectedKonbiniCode": zod.enum(['SEVEN_ELEVEN', 'LAWSON', 'FAMILYMART', 'MINISTOP', 'SEICOMART']).optional().describe('初期選択されたコンビニコード（selectedPaymentChannel=CVS の場合）'),
  "receiptNumber": zod.string().optional().describe('コンビニ払い番号（CVS時）'),
  "paymentDueDate": zod.string().date().optional().describe('支払期限（CVS時）'),
  "requiresAction": zod.boolean().describe('追加アクション要否（3DS等）。作成時点では常に false。決済起動後の確定値は GET /invoices/* で取得してください。'),
  "redirectUrl": zod.string().url().optional().describe('追加アクション遷移先（3DS等）')
}).strict().describe('請求発行結果（作成時点のスナップショット）。\n初回決済はトランザクションコミット後に非同期で起動されるため、paymentId/paymentStatus/receiptNumber/paymentDueDate/redirectUrl は作成直後は null になり得ます。\nrequiresAction は作成時点では常に false を返します。3DS 等の追加アクションが必要になった場合は、決済起動後に GET /invoices/* で確認してください。\n')

/**
 * 請求IDに対応する詳細情報を返します。
 * @summary 請求の詳細情報を取得する
 */
export const InvoiceGetDetailParams = zod.object({
  "invoiceId": zod.string().uuid().describe('請求ID（UUID）')
}).strict()

export const invoiceGetDetailResponseInvoiceAmountMultipleOf = 1;

export const invoiceGetDetailResponseInvoicePdfResourcePathRegExp = new RegExp('^/(patients|uploads)/.+');
export const invoiceGetDetailResponseStatementPdfResourcePathRegExp = new RegExp('^/(patients|uploads)/.+');
export const invoiceGetDetailResponseAdditionalAttachmentResourcePathsItemMax = 2048;


export const invoiceGetDetailResponseAdditionalAttachmentResourcePathsItemRegExp = new RegExp('^/(patients|uploads)/.+');
export const invoiceGetDetailResponseAdditionalAttachmentResourcePathsMax = 10;

export const invoiceGetDetailResponseReceiptNumberMax = 128;



export const InvoiceGetDetailResponse = zod.object({
  "id": zod.string().uuid().describe('請求ID（UUID）'),
  "invoiceAmount": zod.number().multipleOf(invoiceGetDetailResponseInvoiceAmountMultipleOf).describe('請求金額（通貨: JPY・税込）'),
  "invoicePdfResourcePath": zod.string().refine((v) => invoiceGetDetailResponseInvoicePdfResourcePathRegExp.test(v)).optional().describe('請求書PDFのメディアリソースパス（例: /patients/{patientId}/... または /uploads/{organizationId}/...、任意）'),
  "statementPdfResourcePath": zod.string().refine((v) => invoiceGetDetailResponseStatementPdfResourcePathRegExp.test(v)).optional().describe('明細書PDFのメディアリソースパス（例: /patients/{patientId}/... または /uploads/{organizationId}/...、任意）'),
  "additionalAttachmentResourcePaths": zod.array(zGraphemeString({ max: invoiceGetDetailResponseAdditionalAttachmentResourcePathsItemMax }).refine((v) => invoiceGetDetailResponseAdditionalAttachmentResourcePathsItemRegExp.test(v))).max(invoiceGetDetailResponseAdditionalAttachmentResourcePathsMax).optional().describe('その他添付のメディアリソースパス一覧（任意）'),
  "issuedDate": zod.string().date().describe('発行日（YYYY-MM-DD）'),
  "issuerName": zod.string().describe('発行者名'),
  "payeeName": zod.string().describe('支払い先名'),
  "isPaid": zod.boolean().describe('入金済みフラグ'),
  "invoiceLifecycleStatus": zod.enum(['NOT_BILLED', 'ACTIVE', 'PAID', 'REISSUED', 'CANCELLED']).describe('請求ライフサイクルステータス'),
  "paymentStatus": zod.enum(['企業請求', '未納', '決済エラー（カード）', '決済エラー（コンビニ）', 'カード決済済み', 'コンビニ決済済み', 'キャンセル済み', 'キャンセル済み（企業請求）']).describe('支払いステータス（表示ラベル）'),
  "selectedPaymentChannel": zod.enum(['CARD', 'CVS', 'COMPANY_DIRECT']).optional().describe('選択中の支払いチャネル（任意）'),
  "availablePatientActions": zod.array(zod.enum(['CHANGE_CARD', 'SWITCH_CHANNEL', 'SWITCH_KONBINI'])).describe('患者が実行可能なアクション一覧'),
  "konbiniCode": zod.enum(['SEVEN_ELEVEN', 'LAWSON', 'FAMILYMART', 'MINISTOP', 'SEICOMART']).optional().describe('コンビニ会社コード（CVS時、任意）'),
  "latestPaymentStatus": zod.string().optional().describe('最新決済試行の内部ステータス（任意）'),
  "latestFailureReason": zod.string().optional().describe('最新決済試行の失敗理由（任意）'),
  "latestPaymentAttemptedAt": zod.string().datetime({"offset":true}).optional().describe('最新決済試行日時（任意）'),
  "receiptNumber": zGraphemeString({ max: invoiceGetDetailResponseReceiptNumberMax }).optional().describe('コンビニ払い番号（CVS時、任意）'),
  "paymentDueDate": zod.string().date().nullish().describe('支払期限（CVS時、任意）'),
  "paidDate": zod.string().date().nullable().describe('入金日（YYYY-MM-DD）。未入金の場合はnull。'),
  "createdAt": zod.string().datetime({"offset":true}).describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict().describe('特定患者に対する請求情報')

/**
 * オンライン診療予約および紹介状依頼を基点に、請求発行に利用できる候補の一覧を返します。
 *
 * UI例（請求情報の一覧）に対応するため、以下のフィルタ/検索をサポートします:
 * - appointmentDateFrom/appointmentDateTo: 診療予約日時の範囲でフィルタします。
 * - nameKana: 患者名（ふりがな）の部分一致検索に使用します。
 * - companyName: 所属企業名の部分一致検索に使用します。
 * - phoneNumber: 電話番号の部分一致検索に使用します。
 * - patientLocalId: 患者識別番号（医療機関独自の番号）の部分一致検索に使用します。
 * - patientOrganization[id]: 予約（紹介状依頼）時点の患者の所属組織でフィルタします（deepObject）。
 *   ops-admin/ops-operator は、指定した組織の配下の組織も含めて絞り込みます。医療機関スタッフは指定した組織との完全一致です。
 * - reservationStatus: 予約の状態でフィルタします（例: 診察実施済み、請求処理済み）。
 * - hasIdentityDocument: 本人確認書類の登録有無でフィルタします。
 * - invoiceStatus: 請求状況でフィルタします（NOT_BILLED/ISSUED/PAID/REISSUED/CANCELLED）。
 * @summary 請求候補の一覧を取得する
 */
export const invoiceListCandidatesQueryPageDefault = 0;
export const invoiceListCandidatesQueryPageMin = 0;

export const invoiceListCandidatesQuerySizeDefault = 20;
export const invoiceListCandidatesQuerySizeMax = 2000;

export const invoiceListCandidatesQuerySortDefault = `createdAt,desc`;
export const invoiceListCandidatesQueryNameKanaMax = 200;

export const invoiceListCandidatesQueryPhoneNumberMin = 6;
export const invoiceListCandidatesQueryPhoneNumberMax = 20;

export const invoiceListCandidatesQueryPatientLocalIdMax = 100;


export const invoiceListCandidatesQueryCompanyNameMax = 200;



export const InvoiceListCandidatesQueryParams = zod.object({
  "page": zod.number().int().min(invoiceListCandidatesQueryPageMin).default(invoiceListCandidatesQueryPageDefault).describe('取得ページ番号（0開始）'),
  "size": zod.number().int().min(1).max(invoiceListCandidatesQuerySizeMax).default(invoiceListCandidatesQuerySizeDefault).describe('1ページあたりの件数'),
  "sort": zod.string().default(invoiceListCandidatesQuerySortDefault).describe('ソートキー（例: createdAt,desc）'),
  "appointmentDateFrom": zod.string().datetime({"offset":true}).optional().describe('フィルタ用の診療予約日時（開始; RFC3339 date-time）'),
  "appointmentDateTo": zod.string().datetime({"offset":true}).optional().describe('フィルタ用の診療予約日時（終了; RFC3339 date-time）'),
  "nameKana": zGraphemeString({ min: 1, max: invoiceListCandidatesQueryNameKanaMax }).optional().describe('患者名（ふりがな）での部分一致検索に使用します。'),
  "phoneNumber": zGraphemeString({ min: invoiceListCandidatesQueryPhoneNumberMin, max: invoiceListCandidatesQueryPhoneNumberMax }).optional().describe('電話番号の部分一致検索に使用します。'),
  "patientLocalId": zGraphemeString({ min: 1, max: invoiceListCandidatesQueryPatientLocalIdMax }).optional().describe('患者識別番号（医療機関独自の番号）の部分一致検索に使用します。'),
  "patientId": zod.string().uuid().optional().describe('患者ID（UUID）で請求候補を絞り込みます。'),
  "patientOrganization": zod.union([zod.object({
  "id": zod.string().uuid()
}).strict(),zod.object({
  "name": zGraphemeString({ min: 1 })
}).strict()]).optional().describe('患者フィルタ用の所属組織（id または name のいずれかを指定）'),
  "reservationStatus": zod.enum(['reserved', 'examined', 'invoiced', 'cancelled', 'no_show']).optional().describe('予約ステータスカテゴリでフィルタします（reserved|examined|invoiced|cancelled|no_show）。\n\nカテゴリの定義:\n- reserved: 予約済み（患者が予約をした状態。内部ステータス pending|confirmed|in_progress を含む。また status が NULL の予約も含みます）\n- examined: 診察実施済み（その予約に診断結果が登録された状態。内部ステータス completed|diagnosed を含む）\n- invoiced: 請求処理済み（その予約に請求が作成され、予約ステータスが invoiced に更新された状態）\n- cancelled: キャンセル（その予約がキャンセルされた状態。内部ステータス cancelled）\n- no_show: 無断キャンセル（診療時刻を過ぎても来院・来訪がなくクリニックが無断キャンセルとして登録した状態。内部ステータス no_show）\n\n後方互換として completed は examined として扱います。\n不正値は無視され（フィルタ非適用）、前後空白は正規化されます。\n'),
  "hasIdentityDocument": zod.boolean().optional().describe('本人確認書類の登録有無でフィルタします'),
  "invoiceStatus": zod.enum(['NOT_BILLED', 'ISSUED', 'PAID', 'REISSUED', 'CANCELLED']).optional().describe('請求状況でフィルタします（NOT_BILLED/ISSUED/PAID/REISSUED/CANCELLED）'),
  "companyName": zGraphemeString({ min: 1, max: invoiceListCandidatesQueryCompanyNameMax }).optional().describe('所属企業名の部分一致検索に使用します')
}).strict()

export const invoiceListCandidatesResponseItemsItemThreePatientNameKanjiMax = 100;

export const invoiceListCandidatesResponseItemsItemThreePatientNameKanaMax = 200;

export const invoiceListCandidatesResponseItemsItemThreeCompanyNameMax = 200;

export const invoiceListCandidatesResponseItemsItemThreeOrganizationHierarchyItemNameMax = 200;

export const invoiceListCandidatesResponseItemsItemThreeOrganizationHierarchyItemDepthMin = 0;


export const invoiceListCandidatesResponseItemsItemThreeInsuranceCardFrontResourcePathOneRegExp = new RegExp('^/patients/.+');
export const invoiceListCandidatesResponseItemsItemThreeBillingStatusLinkMax = 40;

export const invoiceListCandidatesResponseItemsItemThreeAvailableActionsMax = 10;

export const invoiceListCandidatesResponsePagePageMin = 0;

export const invoiceListCandidatesResponsePageSizeMax = 2000;

export const invoiceListCandidatesResponsePageTotalElementsMin = 0;

export const invoiceListCandidatesResponsePageTotalPagesMin = 0;



export const InvoiceListCandidatesResponse = zod.object({
  "items": zod.array(zod.union([zod.object({
  "candidateType": zod.enum(['RESERVATION'])
}).strict(),zod.object({
  "candidateType": zod.enum(['REFERRAL'])
}).strict()]).and(zod.object({
  "reservationId": zod.string().uuid().optional().describe('予約ID（UUID、候補が予約起点の場合に設定）'),
  "appointmentStart": zod.string().datetime({"offset":true}).optional().describe('診療開始日時（RFC3339 date-time）'),
  "appointmentEnd": zod.string().datetime({"offset":true}).optional().describe('診療終了日時（RFC3339 date-time）'),
  "patientId": zod.string().uuid().describe('対象患者のユーザーID（UUID）'),
  "patientNameKanji": zGraphemeString({ min: 1, max: invoiceListCandidatesResponseItemsItemThreePatientNameKanjiMax }).describe('患者名（漢字）'),
  "patientNameKana": zGraphemeString({ min: 1, max: invoiceListCandidatesResponseItemsItemThreePatientNameKanaMax }).describe('患者名（かな）'),
  "companyName": zGraphemeString({ min: 1, max: invoiceListCandidatesResponseItemsItemThreeCompanyNameMax }).describe('所属企業名'),
  "organizationHierarchy": zod.array(zod.object({
  "id": zod.string().uuid().describe('組織ID（UUID）'),
  "name": zGraphemeString({ min: 1, max: invoiceListCandidatesResponseItemsItemThreeOrganizationHierarchyItemNameMax }).describe('組織名'),
  "depth": zod.number().int().min(invoiceListCandidatesResponseItemsItemThreeOrganizationHierarchyItemDepthMin).describe('患者の所属組織を0とした、所属組織から当該組織までの最小距離')
}).strict().describe('患者の所属組織、またはその祖先組織')).min(1).describe('予約（紹介状依頼）の時点で記録した患者の所属組織と、その祖先組織。\ndepthの降順（最上位が先頭、末尾が予約時点の所属組織）で返します。\n同じdepthの組織が複数ある場合は組織IDの昇順で返します。\n所属組織が組織階層に参加していない場合は、所属組織1件だけを返します。\n'),
  "candidateType": zod.enum(['RESERVATION', 'REFERRAL']).describe('候補の起点種別（予約起点または紹介状起点）'),
  "billingSubject": zod.string().describe('何に関する請求か（一覧表示用）。\n初期値として以下を使用し、将来は追加値（例: その他）に拡張可能とする。\n- オンライン診療\n- 紹介状発行\n- その他\n'),
  "referralRequestId": zod.string().uuid().optional().describe('紹介状依頼ID（候補が紹介状起点の場合に設定）'),
  "invoiceId": zod.string().uuid().optional().describe('直近の有効な請求ID（請求済み候補の場合に設定）'),
  "insuranceCard": zod.object({
  "frontResourcePath": zod.union([zod.string().refine((v) => invoiceListCandidatesResponseItemsItemThreeInsuranceCardFrontResourcePathOneRegExp.test(v)),zod.null()]).describe('保険証（表面）のメディアリソースパス。未登録の場合はnull。')
}).strict().optional().describe('保険証の署名付きURLセット'),
  "reservationStatus": zod.enum(['reserved', 'examined', 'invoiced', 'cancelled', 'no_show']).optional().describe('予約の状態（集約カテゴリ）。\n- reserved: 予約済み（患者が予約をした状態。内部コード pending|confirmed|in_progress または未設定NULLを含む）\n- examined: 診察実施済み（診断結果が登録された状態。内部コード completed|diagnosed を含む）\n- invoiced: 請求処理済み（請求作成済みで予約ステータスが invoiced に更新された状態）\n- cancelled: キャンセル（予約がキャンセルされた状態。内部コード cancelled）\n- no_show: 無断キャンセル（診療時刻を過ぎても来院・来訪がなくクリニックが無断キャンセルとして登録した状態。内部コード no_show）\n'),
  "referralStatus": zod.enum(['REFERRAL_REQUEST_RECEIVED', 'INVOICE_PROCESSED']).optional().describe('紹介状起点候補のステータス（英語コード）。\nフロントエンドで日本語表示へ読み替える。\n- REFERRAL_REQUEST_RECEIVED: 紹介状発行依頼受領\n- INVOICE_PROCESSED: 請求処理済み\n'),
  "invoiceStatus": zod.enum(['NOT_BILLED', 'ISSUED', 'PAID', 'REISSUED', 'CANCELLED']).describe('請求状況'),
  "latestPaymentStatus": zod.enum(['INIT', 'PENDING', 'SUCCESS', 'FAILED', 'BYPASSED', 'CANCELLED', 'PENDING_RECONCILE']).optional().describe('最新決済試行の内部ステータス（任意）'),
  "latestPaymentChannel": zod.enum(['CARD', 'CVS', 'COMPANY_DIRECT']).optional().describe('最新決済試行のチャネル（任意）'),
  "latestFailureReason": zod.string().optional().describe('最新決済失敗理由（日本語ラベル、医師向け。患者向けにはnull）'),
  "latestPaymentAttemptedAt": zod.string().datetime({"offset":true}).optional().describe('最新決済試行日時（RFC3339、任意）'),
  "canIssueInvoice": zod.boolean().describe('この行に対して請求発行が可能かどうか'),
  "billingStatusLink": zGraphemeString({ min: 1, max: invoiceListCandidatesResponseItemsItemThreeBillingStatusLinkMax }).describe('一覧表示用の請求ステータス文言（例: 未請求、請求済み、支払済み）'),
  "availableActions": zod.array(zod.enum(['ISSUE_INVOICE', 'VIEW_DETAIL', 'REISSUE', 'CANCEL_INVOICE', 'VIEW_DETAIL_OLD_INVOICE'])).min(1).max(invoiceListCandidatesResponseItemsItemThreeAvailableActionsMax).describe('医師一覧で実行可能な操作'),
  "legacyGmoShopTransaction": zod.boolean().describe('この請求に紐づく最新 GMO 取引が現行 shopId と不一致かどうか'),
  "createdAt": zod.string().datetime({"offset":true}).optional().describe('作成日時（RFC3339）'),
  "updatedAt": zod.string().datetime({"offset":true}).describe('更新日時（RFC3339）')
}).strict()).describe('請求候補（オンライン診療および紹介状発行の一覧行データ）')),
  "page": zod.object({
  "page": zod.number().int().min(invoiceListCandidatesResponsePagePageMin).describe('現在のページ番号（0開始）'),
  "size": zod.number().int().min(1).max(invoiceListCandidatesResponsePageSizeMax).describe('1ページあたりの件数'),
  "totalElements": zod.number().int().min(invoiceListCandidatesResponsePageTotalElementsMin).describe('全要素数'),
  "totalPages": zod.number().int().min(invoiceListCandidatesResponsePageTotalPagesMin).describe('全ページ数'),
  "hasNext": zod.boolean().describe('次のページがあるか'),
  "hasPrevious": zod.boolean().describe('前のページがあるか')
}).strict().describe('ページングメタ情報')
}).strict()

